<!-- You can use box variant by mdc-select--box -->
<div class="mdc-select" :class="classes">
    <select ref="selectInput" :disabled="disabled" v-model="selectedValue" class="mdc-select__native-control"
        @change="onInput" @focus="onFocus" @blur="onBlur">
        <option v-if="!value" value="" disabled selected></option>
        <option v-for="option in options"
            :disabled="option.disabled"
            :value="option.value">
            {{ option.label }}
        </option>
    </select>

    <mom-icon class="mdc-select__dropdown-icon" svgIcon="drop-down"></mom-icon>
</div>
